import { ResultsPerPage as ResultsPerPageComponent } from '@coveo/headless';
import { Select, SelectOption } from '@lmig/lmds-react-select';
interface IResultsPerPageProps {
  resultsPerPage: React.MutableRefObject<ResultsPerPageComponent>;
  show: boolean;
}
export default function ResultsPerPage({ resultsPerPage, show }: IResultsPerPageProps) {
  const numberOfResults = resultsPerPage?.current?.state?.numberOfResults;
  const selectedRowsDisplayed =
    numberOfResults !== null && numberOfResults !== undefined
      ? numberOfResults.toString()
      : '10';

  return (
    <>
      {show && (
        <div className="results-per-page">
          <div style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
            <div className="bold">Rows displayed: </div>
            <Select
              id="search-page-rows-displayed"
              className="search-per-page-selector"
              labelVisual=""
              defaultValue={selectedRowsDisplayed}
              onChange={(event: React.FormEvent<HTMLSelectElement>) => {
                if (resultsPerPage?.current === null || resultsPerPage?.current === undefined) {
                  return;
                }

                resultsPerPage.current.set(parseInt(event.currentTarget.value, 10));
              }}
            >
              <SelectOption value="10">10</SelectOption>
              <SelectOption value="20">20</SelectOption>
              <SelectOption value="50">50</SelectOption>
            </Select>
          </div>
        </div>
      )}
    </>
  );
}
